import DatePicker from 'react-datepicker'
import styled from 'styled-components'

import { colors } from '../../../constants'
import Sizes from '../Input.sizes'
import { InputDateRef } from './Input.date'

interface InputProps {
    borderColor?: string | boolean
    ref: InputDateRef
    error?: boolean | string
    size?: Sizes
    style?:any
}

const Input = styled(DatePicker)<InputProps>`
    background: ${colors.greylightest};
    ${({ borderColor }) => (borderColor ? `border: 1px solid ${borderColor};` : `border: 1px solid ${colors.greylight};`)}
    border-radius: 3px;
    outline: none;
    padding: 5px;

    &:active,
    &:focus,
    &:hover {
        border: 1px solid ${colors.grey};
    }

    ${({ error }) =>
        error &&
        `
    border: 1px solid ${colors.red};
  `}

    ${({ size }) => {
        switch (size) {
            case Sizes.SM:
                return 'width: 115px;'
            case Sizes.MD:
                return 'width: 260px;'
            case Sizes.LG:
                return 'width: 400px;'
            default:
                return ''
        }
    }}
    ${({style})=>style?style:{}}
`

export { Input }
